/* tslint:disable */
import {
  BulkSMSRecipient
} from '../index';

declare var Object: any;
export interface BulkSMSInterface {
  "ref_id": number;
  "title": string;
  "sender_id": string;
  "message": string;
  "scheduled_at": Date;
  "sent_by": number;
  "send_now": boolean;
  "sent_status": string;
  "created_at"?: Date;
  "updated_at"?: Date;
  "id"?: number;
  recipients?: BulkSMSRecipient[];
}

export class BulkSMS implements BulkSMSInterface {
  "ref_id": number;
  "title": string;
  "sender_id": string;
  "message": string;
  "scheduled_at": Date;
  "sent_by": number;
  "send_now": boolean;
  "sent_status": string;
  "created_at": Date;
  "updated_at": Date;
  "id": number;
  recipients: BulkSMSRecipient[];
  constructor(data?: BulkSMSInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `BulkSMS`.
   */
  public static getModelName() {
    return "BulkSMS";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of BulkSMS for dynamic purposes.
  **/
  public static factory(data: BulkSMSInterface): BulkSMS{
    return new BulkSMS(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'BulkSMS',
      plural: 'BulkSMS',
      path: 'BulkSMS',
      idName: 'id',
      properties: {
        "ref_id": {
          name: 'ref_id',
          type: 'number'
        },
        "title": {
          name: 'title',
          type: 'string'
        },
        "sender_id": {
          name: 'sender_id',
          type: 'string'
        },
        "message": {
          name: 'message',
          type: 'string'
        },
        "scheduled_at": {
          name: 'scheduled_at',
          type: 'Date'
        },
        "sent_by": {
          name: 'sent_by',
          type: 'number'
        },
        "send_now": {
          name: 'send_now',
          type: 'boolean'
        },
        "sent_status": {
          name: 'sent_status',
          type: 'string',
          default: 'SENT'
        },
        "created_at": {
          name: 'created_at',
          type: 'Date'
        },
        "updated_at": {
          name: 'updated_at',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        recipients: {
          name: 'recipients',
          type: 'BulkSMSRecipient[]',
          model: 'BulkSMSRecipient',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'ref_id'
        },
      }
    }
  }
}
